module.exports = __webpack_public_path__ + "ffac2845124f86fbfbdda1e409c05db2.png";